/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_Erasure_DescInputs */

const en_privacy_section_7_erasure_desc = /** @type {(inputs: Privacy_Section_7_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`request deletion of your personal data`)
};

const lv_privacy_section_7_erasure_desc = /** @type {(inputs: Privacy_Section_7_Erasure_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pieprasīt Jūsu personas datu dzēšanu`)
};

/**
* | output |
* | --- |
* | "request deletion of your personal data" |
*
* @param {Privacy_Section_7_Erasure_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_erasure_desc = /** @type {((inputs?: Privacy_Section_7_Erasure_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_Erasure_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_erasure_desc(inputs)
	return en_privacy_section_7_erasure_desc(inputs)
});